import { render, staticRenderFns } from "./TechnologyComponent.vue?vue&type=template&id=3ca341ea&scoped=true"
import script from "./TechnologyComponent.vue?vue&type=script&lang=js"
export * from "./TechnologyComponent.vue?vue&type=script&lang=js"
import style0 from "./TechnologyComponent.vue?vue&type=style&index=0&id=3ca341ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca341ea",
  null
  
)

export default component.exports